import React from 'react'
import styled from 'styled-components'
// import Button from '../SubComponents/Button'
import RedButton from '../SubComponents/RedButton'
import GreenButton from '../SubComponents/GreenButton'

const Section = styled.div`
width: 100vw;
height: 100vh;
background-color: burlywood;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
`

const ChatBox = styled.div`
margin: 2rem;

`

const Message = styled.div`
width: 80%;
height: auto;
margin: 1rem;
display: flex;
justify-content: space-evenly;
align-items: center;

input{
  width: 60%;
  height: 2rem;

}
`

const Chat = () => {
  return (
    <Section>
    <h1>Chat</h1>
    <h3>You are currently in the Chat Room</h3>
    <ChatBox>
    <textarea placeholder='No messages yet...' id="chat" rows={16} cols={80} />
    </ChatBox>
    <Message>
    <input placeholder='Type a message..' id="message" type="text" />
    <GreenButton id="send" text="message" />
    </Message>
    <RedButton id="leave" text="Exit the room" />
    </Section>
  )
}

export default Chat